<template>
  <div class="shoes">
    <h1>ブランドごとの靴のサイズ変換メーカー</h1>
    <div class="block">
        <b-radio v-model="sex" native-value= 'male'>男</b-radio>
        <b-radio v-model="sex" native-value= 'female'>女</b-radio>
    </div>
    <div class="block">
        <b-radio v-model="country" native-value= "JPN">日本</b-radio>
        <b-radio v-model="country" native-value= "USA">アメリカ</b-radio>
        <b-radio v-model="country" native-value= "UK">イギリス</b-radio>
        <b-radio v-model="country" native-value= "EUR">ヨーロッパ</b-radio>
    </div>
    <b-table :data="data" :columns="men_columns"></b-table>
  </div>
</template>

<script>

export default {
  name: 'home',
  data() {
    return {
        sex:"male",
        country: 'JPN',
        answer: '',
        male:[
            { 'sex':'male','country': "JPN", 'unit': 'cm', 'size':{ '25': '25', '25_5': '25.5', '26': '26', '26_5': '26.5', '27': '27', '27_5': '27.5', '28': '28', '28_5': '28.5', '29': '29', '29_5': '29.5', '30': '30'}},
            { 'sex':'male','country': "USA", 'unit': 'inch', 'size':{ '25': '7', '25_5': '7.5',  '26': '8', '26_5': '8.5', '27': '9', '27_5': '9.5', '28': '10', '28_5': '10.5', '29': '11', '29_5': '11.5', '30': '12' }},
            { 'sex':'male','country': "UK", 'unit': 'inch', 'size':{ '25': '6.5', '25_5': '7', '26': '7.5', '26_5': '8', '27': '8.5', '27_5': '9', '28': '9.5', '28_5': '10', '29': '10.5', '29_5': '11', '30': '11.5' }},
            { 'sex':'male','country': "EUR", 'unit': 'inch','size':{  '25': '40', '25_5': '40 2/3',  '26': '41 1/3', '26_5': '42', '27': '42 2/3', '27_5': '43 1/3', '28': '44', '28_5': '44 2/3', '29': '45 2/3', '29_5': '46', '30': '46 2/3' }},
        ],
        female:[
            {"a":"b"},
            {"a":"b"},
            {"a":"b"},
            {"a":"b"},
        ],
        data: [
            { 'country': "日本(JPN)", 'unit': 'cm', '25': '25', '25_5': '25.5', '26': '26', '26_5': '26.5', '27': '27', '27_5': '27.5', '28': '28', '28_5': '28.5', '29': '29', '29_5': '29.5', '30': '30'},
            { 'country': "アメリカ(USA)", 'unit': 'inch', '25': '7', '25_5': '7.5',  '26': '8', '26_5': '8.5', '27': '9', '27_5': '9.5', '28': '10', '28_5': '10.5', '29': '11', '29_5': '11.5', '30': '12' },
            { 'country': "イギリス(UK)", 'unit': 'inch', '25': '6.5', '25_5': '7', '26': '7.5', '26_5': '8', '27': '8.5', '27_5': '9', '28': '9.5', '28_5': '10', '29': '10.5', '29_5': '11', '30': '11.5' },
            { 'country': "ヨーロッパ(EUR)", 'unit': 'inch', '25': '40', '25_5': '40 2/3',  '26': '41 1/3', '26_5': '42', '27': '42 2/3', '27_5': '43 1/3', '28': '44', '28_5': '44 2/3', '29': '45 2/3', '29_5': '46', '30': '46 2/3' },
        ],
        men_columns: [
                    {
                        field: 'country',
                        label: '国',
                        width: '16',
                        numeric: true
                    },
                    {
                        field: 'unit',
                        width: '16',
                    },
                   {
                        field: '25',
                        width: '16',
                    },
                    {
                        field: '25_5',
                        width: '16',
                    },
                    {
                        field: '26',
                        width: '16',
                    },
                    {
                        field: '26_5',
                        width: '16',
                    },
                    {
                        field: '27',
                        width: '16',
                    },
                    {
                        field: '27_5',
                        width: '16',
                    },
                    {
                        field: '28',
                        width: '16',
                    },
                    {
                        field: '28_5',
                        width: '16',
                    },
                    {
                        field: '29',
                        width: '16',
                    },
                    {
                        field: '29_5',
                        width: '16',
                    },
                    {
                        field: '30',
                        width: '16',
                    },
                ]
    }
  },
}
</script>

<style scoped>

</style>